'use client'

import ReactDOM from 'react-dom'

export function ResourceHints() {
  // S3 is cross-origin, so DNS-prefetch is the safer default:
  ReactDOM.prefetchDNS('https://cdn.msu.edu.in')

  // Only keep this if the homepage definitely needs an above-the-fold
  // image/video/poster from S3 during the initial render:
  // ReactDOM.preconnect(
  //   'https://cdn.msu.edu.in',
  //   { crossOrigin: '' }
  // )

  return null
}